// Vuex - modules (myprotein)

import {SET_PROTEIN_QUIZ, SET_PROTEIN_SELF_CHECK , SET_PROTEIN_PURPOSE} from '../actions/myprotein'

const mutations = {

    [SET_PROTEIN_QUIZ](state,data) {
        state.proteinQuiz = data;
    },
    [SET_PROTEIN_SELF_CHECK](state,data) {
        state.proteinSelfCheck = data;
    },
    [SET_PROTEIN_PURPOSE](state , data) {
        state.proteinPurpose = data;
    }
}

export default {
    namespaced : true,
    mutations
}